import { NotificationV2 } from '@/types/generated/graphql';

export function attributesParser(notification: NotificationV2, dynamicTextObj: Record<string, string>) {
  if (!notification.replacementAttributes?.length) return notification.body;
  const notificationBody = notification?.body ?? '';

  const parsedBody: string[] = notificationBody.split(' ').map((str: string) => {
    const isDynamic = str.includes('{{') && str.includes('}}'); // check for dynamic text
    if (!isDynamic) return str + ' ';

    const key = str.substring(2, str.indexOf('}')); // extract text between {{}}
    return `<b>${dynamicTextObj[key]}</b>` + ' '; // insert object value and font-bold
  });
  return parsedBody.join('');
}

export const replacementAttributesObj = (notification: NotificationV2) =>
  notification?.replacementAttributes?.reduce((acc, curr) => {
    return {
      ...acc,
      [curr?.key + '']: curr?.value,
    };
  }, {}) as Record<string, string>;
